import { Component, Input } from '@angular/core';
import { Message } from 'primeng/api';
import { County } from '../../../../../../foundation/models/enums/county.enum';
import { Jurisdiction } from '../../../../../../foundation/models/enums/jurisdiction.enum';
import { BaseComponent } from '../../../../../../shared/base-components/base.component';
import { MvdModalService } from '../../../../../../shared/services/modal/mvd-modal.service';
import { VehicleOwnershipModel } from '../../../../../../titleregistration/models/vehicle-ownership.model';
import { OwnershipService } from '../../../../../../titleregistration/services/ownership.service';
import { VehicleAddressModel } from '../../../../../models/vehicle-address.model';
import { VehicleMobileHomeModel } from '../../../../../models/vehicle-mobile-home.model';
import { VehicleDomicileService } from '../../../../../services/vehicle-domicile.service';
import { VehicleMobileHomeService } from '../../../../../services/vehicle-mobile-home.service';
import { LinkMobileHomeSectionModalComponent, LinkMobileHomeSectionModalData } from '../link-mobile-home-section-modal/link-mobile-home-section-modal.component';

@Component({
    selector: 'mobile-home-linked-sections',
    templateUrl: './mobile-home-linked-sections.html'
})

export class MobileHomeLinkedSectionsComponent extends BaseComponent {
    @Input() vehicleId: number;
    @Input() vehicleOwnership: VehicleOwnershipModel;

    jurisdictions = new Jurisdiction().GetAll();
    counties = new County().GetAll();

    linkedSections: VehicleMobileHomeModel[];
    domicileAddress: VehicleAddressModel;
    isAddressMasked = false;
    public growlMessages: Message[] = [];

    constructor(private mobileHomeService: VehicleMobileHomeService,
        private modalService: MvdModalService,
        private ownershipService: OwnershipService,
        private vehicleDomicileService: VehicleDomicileService
    ) {
        super();
    }

    ngOnInit() {
        this.refreshLinkedSections();
        this.getDomicileAddress();
    }

    linkSection() {
        const data = new LinkMobileHomeSectionModalData(this.vehicleId);
        this.modalService.open(LinkMobileHomeSectionModalComponent, data)
            .afterClosed()
            .subscribe(
                result => {
                    if (result) {
                        this.refreshLinkedSections();
                    }
                },
                error => this.handleValidationResult(error)
            );
    }

    addDomicile() {
        this.vehicleDomicileService.addDomicile(this.vehicleOwnership, this.growlMessages, s => this.getDomicileAddress());
    }

    editDomicile() {
        this.vehicleDomicileService.editDomicile(this.vehicleOwnership, this.growlMessages, s => this.getDomicileAddress());
    }

    deleteDomicile() {
        this.vehicleDomicileService.deleteDomicile(this.vehicleOwnership, this.growlMessages, () => this.getDomicileAddress());
    }

    delete(vehicleId: number) {
        this.mobileHomeService.deleteMobileHomeRelatedVehicle(vehicleId).subscribe(
            result => {
                this.mobileHomeService.getMobileHomeRelatedVehicles(this.vehicleId).subscribe(
                    result => {
                        this.linkedSections = result;
                    },
                    error => this.handleValidationResult(error)
                );
            },
            error => this.handleValidationResult(error)
        );
    }

    viewVehicle(vehicleId) {
        window.open('../vehicle/vehicleinformation/' + vehicleId);
    }

    private refreshLinkedSections() {
        this.mobileHomeService.getMobileHomeRelatedVehicles(this.vehicleId).subscribe(
            result => {
                this.linkedSections = result;
            },
            error => this.handleValidationResult(error)
        );
    }

    private getDomicileAddress(): void {
        if (this.vehicleOwnership?.id) {
            this.ownershipService.getDomicileAddressByVehicleOwnershipId(this.vehicleOwnership.id).subscribe(
                result => {
                    this.domicileAddress = result;
                    if (this.domicileAddress && this.domicileAddress.addressLine1.indexOf('****') > -1) {
                        this.isAddressMasked = true;
                    }
                    this.vehicleOwnership.vehicleAddress = result;
                },
                error => this.handleValidationResult(error)
            );
        }
    }
}
